export default __webpack_public_path__ + "static/media/Proionta_syskeyasias.529bcbf7.jpg";